import { render, staticRenderFns } from "./UploadDados.vue?vue&type=template&id=24d56402"
import script from "./UploadDados.vue?vue&type=script&lang=js"
export * from "./UploadDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports